import React, { useState } from 'react'
import { API_ENDPOINTS } from '../../config/api';

function BannerSix() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });
    const [loading, setLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatusMessage('');

        try {
            const response = await fetch(API_ENDPOINTS.SEND_EMAIL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name: formData.name,
                    email: formData.email,
                    subject: formData.phone ? `Contact Request - Phone: ${formData.phone}` : 'Contact Request',
                    message: formData.message
                })
            });

            const data = await response.json();

            if (response.ok && data.success) {
                setStatusMessage('✓ ' + data.message);
                setFormData({ name: '', email: '', phone: '', message: '' });
            } else {
                setStatusMessage('✗ ' + (data.message || 'Failed to send message'));
            }
        } catch (error) {
            console.error('Contact form error:', error);
            setStatusMessage('✗ Failed to send message. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            {/* rts banner darea start */}
            <div className="rts-banner-area banner-bg-h7">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-7">
                            {/* bannerq inner six */}
                            <div className="rts-banner-wrapper-seven">
                                <p className="pre-title">
                                    <span>Welcome!</span> ICAEW and ACCA certified. UK-wide service.
                                </p>
                                <h1 className="banner-title">
                                    Trusted Accountants for Growing <br />
                                    Businesses Across the <span>United Kingdom</span>
                                </h1>
                                <p className="disc">
                                    You want numbers you can trust and advice you can use. Aviteus Business Solutions helps SMEs and startups across the UK with bookkeeping, payroll, VAT, tax and clear financial guidance. Our chartered team uses Xero, Sage or QuickBooks to keep your records accurate, compliant and ready for growth. You get fixed pricing, plain language and a dedicated manager who understands your goals.
                                </p>
                                <div className="button-area">
                                    <a href="/services" className="rts-btn btn-primary six mr--30">
                                        Our Services
                                    </a>
                                    <a href="/contactus" className="rts-btn btn-primary deactive">
                                        Book a Free Consultation
                                    </a>
                                </div>
                            </div>
                            {/* bannerq inner six ENd */}
                        </div>
                        <div className="col-xl-5">
                            <div className="rts-contact-form-area six">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="rts-contact-fluid">
                                                <div className="rts-title-area contact-fluid text-center">
                                                    <h2 className="title">Let’s Get in Touch</h2>
                                                </div>
                                                <div className="form-wrapper">
                                                    {statusMessage && (
                                                        <div id="form-messages" style={{
                                                            padding: '12px',
                                                            marginBottom: '15px',
                                                            borderRadius: '5px',
                                                            backgroundColor: statusMessage.startsWith('✓') ? '#d4edda' : '#f8d7da',
                                                            color: statusMessage.startsWith('✓') ? '#155724' : '#721c24',
                                                            border: `1px solid ${statusMessage.startsWith('✓') ? '#c3e6cb' : '#f5c6cb'}`,
                                                            fontSize: '14px',
                                                            textAlign: 'center'
                                                        }}>
                                                            {statusMessage}
                                                        </div>
                                                    )}
                                                    <form id="contact-form" onSubmit={handleSubmit}>
                                                        <input
                                                            type="text"
                                                            name="name"
                                                            placeholder="Your Name"
                                                            value={formData.name}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                        <input
                                                            type="email"
                                                            name="email"
                                                            placeholder="Your Email"
                                                            value={formData.email}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                        <input
                                                            type="tel"
                                                            name="phone"
                                                            placeholder="Phone Number (Optional)"
                                                            value={formData.phone}
                                                            onChange={handleChange}
                                                        />
                                                        <textarea
                                                            placeholder="Type Your Message"
                                                            name="message"
                                                            value={formData.message}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                        <button type="submit" className="rts-btn btn-primary" disabled={loading}>
                                                            {loading ? 'Sending...' : 'Submit'}
                                                        </button>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="shape-banner-6">
                    <img
                        src="assets/images/banner/shape/shape-h6.png"
                        alt="shape-images"
                        data-sal-delay={150}
                        data-sal="slide-right"
                        data-sal-duration={800}
                    />
                </div>
            </div>
            {/* rts banner darea end */}
        </div>
    )
}

export default BannerSix